import * as types from "../actions/types";

const initialState = {
    user: null,
    currentorganization: null,
    usergroups: null,
    accessrights: null
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CURRENTUSER_COMPLETED:
            return Object.assign({}, state, {
                user: action.assets
            });
        case types.GET_ORGANIZATION_COMPLETED:
            return Object.assign({}, state, {
                currentorganization: action.assets
            });
        case types.GET_CURRENTUSER_USERGROUPS_COMPLETED:
            return Object.assign({}, state, {
                usergroups: action.assets
            });
        case types.GET_CURRENTUSER_ACCESSRIGHTS_COMPLETED:
            return Object.assign({}, state, {
                accessrights: action.assets
            });
        case types.SET_CURRENTUSER_NEWSETTINGS:
            return Object.assign({}, state, {
                newSettings: action.assets
            });

        default:
            return state;
    }
};
